// One icon in a task group's toolbar (S128): a square link named by its label, which its tooltip
// shows with an optional hint underneath, as the folded rail's items are (layout/SidebarMenu.tsx).
import type { ReactNode } from "react";
import { Link } from "react-router";
import { Tooltip } from "rizzui";

export const TOOL_CLASS =
  "relative inline-flex h-9 w-9 items-center justify-center rounded-lg text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-1000 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50";

export function ToolTip({ label, hint }: { label: string; hint?: string }) {
  return (
    <span className="flex max-w-64 flex-col gap-0.5">
      <span className="font-medium">{label}</span>
      {hint ? <span className="opacity-80">{hint}</span> : null}
    </span>
  );
}

interface Props {
  to: string;
  label: string;
  hint?: string;
  icon: ReactNode;
  testId?: string;
}

export function ToolLink({ to, label, hint, icon, testId }: Props) {
  return (
    <Tooltip content={<ToolTip label={label} hint={hint} />} placement="bottom">
      <Link to={to} aria-label={label} className={TOOL_CLASS} data-testid={testId}>
        {icon}
      </Link>
    </Tooltip>
  );
}
